const nameData = "depositos"; // Define la entidad dinámica
const nameDataSingular = "deposito"; // Para el caso singular

export const fetchEntityData = async (getEntityPanelData, searchTerm, searchIDFilter, numPagina, filas) => {
  try {
    const data = await getEntityPanelData(searchTerm,searchIDFilter, numPagina, filas);
    if (data) {
      return {
        dataEntity:  data[nameData] || [],
      };
    }
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};

export const deleteItem = async (deleteEntityData, selectedItem) => {
  try {
    await deleteEntityData(selectedItem);
  } catch (error) {
    console.error(`Error al eliminar el ${nameDataSingular}:`, error);
    throw error;
  }
};
